import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Collapse, { Panel } from 'rc-collapse';
import TextField from '../form/base/TextField';

class ContactTab extends Component {
  render() {
    // const entity = store.getState().entity;
    // const headerText = Object.keys(entity).length > 0 ? 'pri Contact' : 'Submitter Contact';
    const headerText = 'Submitter Contact';

    return (
      <div>
        <h2>Contact</h2>
        <div className="description">The contact information will not be accessible to anyone other than NPIN staff.
          NPIN staff will use this information to periodically update your organization information.
        </div>
        <Collapse accordion={false} defaultActiveKey={['0', '1']}>
          <Panel header={headerText}>
            <TextField label="First Name"
              name="contact_pri_first_name"/>
            <TextField label="Last Name"
              name="contact_pri_last_name"/>
            <TextField label="Job Title"
              name="contact_pri_job_title" />
            <TextField label="Email"
              hint="name@example.com"
              name="contact_pri_email"/>
            <TextField label="Phone"
              name="contact_pri_phone_number"
              hint="XXX-XXX-XXXX" />
            <TextField label="Extension"
              name="contact_pri_phone_ext" />
            <TextField label="Phone Note"
              name="contact_pri_phone_note" />
          </Panel>
          <Panel header="Secondary Contact">
            <TextField label="First Name"
              name="contact_sec_first_name" />
            <TextField label="Last Name"
              name="contact_sec_last_name" />
            <TextField label="Job Title"
              name="contact_sec_job_title" />
            <TextField label="Email"
              hint="name@example.com"
              name="contact_sec_email" />
            <TextField label="Phone"
              hint="XXX-XXX-XXXX"
              name="contact_sec_phone_number" />
            <TextField label="Extension"
              name="contact_sec_phone_ext" />
            <TextField label="Phone Note"
              name="contact_sec_phone_note" />
          </Panel>
        </Collapse>
        <div className="submit">
          <button type="button" className='usa-button' onClick={this.props.nextTab}>Save and continue</button>
        </div>
      </div>
    )
  }
}

ContactTab.propTypes = {
  entity: PropTypes.object
};

export default ContactTab;
